export const STATUS_LABELS: Record<string, string> = {
  draft: 'Rascunho',
  pending_review: 'Em Review',
  approved: 'Aprovada',
  active: 'Ativa',
  deprecated: 'Deprecada',
  community_submitted: 'Comunidade',
};
